import TaskTypeEscalationMatricesResource from 'esm-web-pro/api/resources/TaskTypeEscalationMatricesResource';
import { AuthResource } from 'speed-js-core';
import AbsorptionResource from './AbsorptionResource';
import AccountIntegrationHeadingResource from './AccountIntegrationHeadingResource';
import AccountingPeriodResource from './AccountingPeriodResource';
import AccountingRangeResource from './AccountingRangeResource';
import AddressGEOResource from './AddressGEOResource';
import AddressMapResource from './AddressMapResource';
import AddressResource from './AddressResource';
import AddressAttributeResource from './AddressAttributeResource';
import AddTaskTicketsResource from './AddTaskTicketsResource';
import AirRouteResource from './AirRouteResource';
import AttachmentResource from './AttachmentResource';
import AttributeResource from './AttributeResource';
import AttributeTypeResource from './AttributeTypeResource';
import AuditEventResource from './AuditEventResource';
import AuditEventTypeResource from './AuditEventTypeResource';

import BankAccountResource from './BankAccountResource';
import BillingAccountResource from './BillingAccountResource';
import BillingAccountTransactionResource from './BillingAccountTransactionResource';
import BillingAccountAbsorptionResource from './BillingAccountAbsorptionResource';
import BillingAccountFinancialDocumentsResource from './BillingAccountFinancialDocumentsResource';
import BillingPeriodResource from './BillingPeriodResource';
import BillingPolicyResource from './services/BillingPolicyResource';
import BillsResource from './BillsResource';

import CabinetGEOResource from './CabinetGEOResource';
import CabinetResource from './CabinetResource';
import CableGEOResource from './CableGEOResource';
import CableReserveResource from './CableReserveResource';
import CableResource from './CableResource';
import CableModelNomenclatureResource from './CableModelNomenclatureResource';
import CableModelResource from './CableModelResource';
import CallDetailRecordResource from './CallDetailRecordResource';
import CashAccountResource from './CashAccountResource';
import CeleryTaskResource from './CeleryTaskResource';
import CheckedAddressResource from './CheckedAddressResource';
import CitiesResource from './CitiesResource';
import ClientOrganisationResource from './ClientOrganisationResource';
import ClientPersonResource from './ClientPersonResource';
import AnonymousOrganisationResource from './AnonymousOrganisationResource';
import AnonymousPersonResource from './AnonymousPersonResource';
import ClientResource from './ClientResource';
import ClientWFEntityResource from './ClientWFEntityResource';
import ClientSystemResource from './ClientSystemResource';
import ContinuousPipeMapResource from './ContinuousPipeMapResource';

import CommentResource from './CommentResource';
import ContactsResource from './ContactsResource';
import ContactDetailResource from './ContactDetailResource';
import ContinuousPipeResource from './ContinuousPipeResource';
import CouplerResource from './CouplerResource';
import CouplerMapResource from './CouplerMapResource';
import CoverageGEOResource from './CoverageGEOResource';
import CoverageResource from './CoverageResource';
import CurrencyResource from './CurrencyResource';

import DataPortResource from './DataPortResource';
import DataPortMapResource from './DataPortMapResource';
import DocumentResource from './DocumentResource';
import DocumentTypeResource from './DocumentTypeResource';
import DocumentArchiveLocationResource from './DocumentArchiveLocationResource';

import EITExportResource from './EITExportResource';
import EntityPaymentMethodsResource from './EntityPaymentMethodsResource';
import EmployeeResource from './EmployeeResource';
import EntityResource from './EntityResource';
import EntityInternalTransactionProtocol from './EntityInternalTransactionProtocol';
import EntityRelatedEntitiesNestedResource from './EntityRelatedEntitiesNestedResource';
import EventResource from './EventResource';
import EventTypeResource from './EventTypeResource';
import ExitResource from './ExitResource';
import EscalationMatricesResource from './EscalationMatricesResource';
import ExportResultResource from './ExportResultResource';

import FiberGEOResource from './FiberGEOResource';
import FiberResource from './FiberResource';
import FileResource from './FileResource';
import FileS3Resource from './FileS3Resource';
import FinancialDocumentResource from './FinancialDocumentResource';
import FinancialDocumentDraftResource from './FinancialDocumentDraftResource';
import FinancialDocumentInternalTransactionProtocolResource
    from './FinancialDocumentInternalTransactionProtocolResource';
import FinancialDocumentListResource from './FinancialDocumentListResource';
import FinancialDocumentRowResource from './FinancialDocumentRowResource';
import FinancialDocumentRowNestedResource from './FinancialDocumentRowNestedResource';
import FinancialDocumentRelatedDocumentsResource from './FinancialDocumentRelatedDocumentsResource';
import FinancialDocumentPaymentNestedResource from './FinancialDocumentPaymentNestedResource';
import ForkGEOResource from './ForkGEOResource';
import ForkResource from './ForkResource';

import GISLineGEOResource from './GISLineGEOResource';
import GISLineResource from './GISLineResource';
import GISPointGEOResource from './GISPointGEOResource';
import GISPointResource from './GISPointResource';
import GISRegionsGEOResource from './GISRegionsGEOResource';
import GroupResource from './GroupResource';
import GroupActionsResource from './GroupActionsResource';

import InfrastructureProviderResource from './InfrastructureProviderResource';
import InternalTransactionProtocolResource from './InternalTransactionProtocolResource';
import InfrastructureDocumentPermitResource from './InfrastructureDocumentPermitResource';
import InventoryTypeResource from './services/InventoryTypeResource';

import LineCutGEOResource from './LineCutGEOResource';
import LineCutResource from './LineCutResource';
import LineResource from './LineResource';
import LocationResource from './LocationResource';

import MainServiceTypeResource from './MainServiceTypeResource';
import MoneyTransferResource from './MoneyTransferResource';
import MoneyTransferDocumentNestedResource from './MoneyTransferDocumentNestedResource';
import MoneyAccountResource from './MoneyAccountResource';
import MoneyTransferTransactionNestedResource from './MoneyTransferTransactionNestedResource';

import NetworksMapResource from './NetworkMapResource';
import NomenclatureItemNestedResource from './NomenclatureItemNestedResource';
import NomenclatureItemResource from './NomenclatureItemResource';
import NotificationTypeResource from './NotificationTypeResource';
import NotificationChannelResource from './NotificationChannelResource';
import NotificationResource from './NotificationResource';
import NotificationScopeResource from './NotificationScopeResource';
import NotificationSubscriptionResource from './NotificationSubscriptionResource';
import NotificationTypeChannelResource from './NotificationTypeChannelResource';
import NomenclatureTypeResource from './NomenclatureTypeResource';
import NotificationTypeScopeResource from './NotificationTypeScopeResource';

import ODFResource from './ODFResource';
import ODFMapResource from './ODFMapResource';
import ODFNonPoPResource from './ODFNonPoPResource';
import ObjectEditabilityResource from './ObjectEditabilityResource';
import ObjectLockResource from './ObjectLockResource';
import ObjectVisibilityResource from './ObjectVisibility';
import OldServiceSubscription from './services/OldServiceSubscriptionResource';
import OpticalODFPortResource from './OpticalODFPortResource';
import OpticalODFPortMapResource from './OpticalODFPortMapResource';
import OpticalSwitchPortResource from './OpticalSwitchPortResource';
import OpticalSwitchPortMapResource from './OpticalSwitchPortMapResource';
import OrganisationRepresentativeResource from './OrganisationRepresentativeResource';
import RepresentativeNestedResource from './RepresentativeNestedResource';
import RepresentingResource from './RepresentingResource';
import OrganisationalRegionResource from './OrganisationalRegionResource';
import OrganisationalUnitResource from './OrganisationalUnitResource';
import OrganisationResource from './OrganisationResource';
import {
    OSSPortResource,
    OSSPortNestedResource,
    OSSSwitchResource,
    OSSLinkResource,
    OSSNodeResource,
    OSSRuleResource,
    OSSLocationResource,
    OSSAccountResource,
    OSSCpeResource,
    OSSPhoneResource,
    OSSNetworkResource,
    OSSDictResource,
    OSSTemplateResource,
    OSSPricingResource,
} from './oss';

import PatchCableResource from './PatchCableResource';
import PaymentMethodResource from './PaymentMethodResource';
import PaymentMethodBillingAccountResource from './PaymentMethodBillingAccountResource';
import PaymentOperatorAccountResource from './PaymentOperatorAccountResource';
import PaymentResource from './PaymentResource';
import PermissionResource from './PermissionResource';
import PersonResource from './PersonResource';
import PhoneResource from './PhoneResource';
import PillarMapResource from './PillarMapResource';
import PillarResource from './PillarResource';
import PipeGEOResource from './PipeGEOResource';
import PipeResource from './PipeResource';
import PoPGEOResource from './PoPGEOResource';
import PoPResource from './PoPResource';
import Point11Resource from './Point11Resource';
import Point12Resource from './Point12Resource';
import PointResource from './PointResource';
import PricingPlanResource from './services/PricingPlanResource';
import ProcessResource from './ProcessResource';
import QuartersResource from './QuartersResource';

import RackMapResource from './RackMapResource';
import RackResource from './RackResource';
import RecurringPeriodResource from './services/RecurringPeriodResource';
import ResidentialTypeResource from './services/ResidentialTypeResource';
import RoleResource from './RoleResource';

import SFPResource from './SFPResource';
import SFPMapResource from './SFPMapResource';
import ServiceParameterResource from './ServiceParameterResource';
import ServiceParameterNestedResource from './ServiceParameterNestedResource';
import ServiceResource from './services/ServiceResource';
import ServiceSubscriptionResource from './services/ServiceSubscriptionResource';
import ServiceDefinitionResource from './services/ServiceDefinitionResource';
import ServiceDefinitionParameterResource from './services/ServiceDefinitionParameterResource';
import ServiceDefinitionParameterChildResource
    from './services/ServiceDefinitionParameterChildResource';
import ServiceDefinitionManyToManyResource from './services/ServiceDefinitionManyToManyResource';
import ServiceManyToManyResource from './services/ServiceManyToManyResource';
import ServiceSubscriptionParameterResource from './services/ServiceSubscriptionParameterResource';
import ServiceSubscriptionParameterChildResource
    from './services/ServiceSubscriptionParameterChildResource';
import ServiceInventorySubscriptionNestedResource
    from './services/ServiceInventorySubscriptionNestedResource';
import SubServiceSubscriptionNestedResource from './services/SubServiceSubscriptionNestedResource';
import ShaftGEOResource from './ShaftGEOResource';
import ShaftResource from './ShaftResource';
import SpliceResource from './SpliceResource';
import SpliceMapResource from './SpliceMapResource';
import StreetsResource from './StreetsResource';
import SystemResource from './SystemResource';
import SwitchResource from './SwitchResource';
import SwitchMapResource from './SwitchMapResource';

import TaskResource from './TaskResource';
import TaskForAnotherOrgUnitResource from './TaskForAnotherOrgUnitResource';
import TaskProcessResource from './TaskProcessResource';
import TaskProcessCounterpartyResource from './TaskProcessCounterpartyResource';
import TaskTicketLinkServiceResource from './TaskTicketLinkServiceResource';
import TaskTicketResource from './TaskTicketResource';
import TechTypeResource from './services/TechTypeResource';
import TemplateResource from './TemplateResource';
import TerminalBoxResource from './TerminalBoxResource';
import TerminalBoxMapResource from './TerminalBoxMapResource';
import TransactionResource from './TransactionResource';
import TransactionFinancialDocumentRowResource from './TransactionFinancialDocumentRowResource';
import TaskProcessCommunicationResource from './TaskProcessCommunicationResource';

import UserResource from './UserResource';

import WallPointGEOResource from './WallPointGEOResource';
import WallPointResource from './WallPointResource';
import WorkflowResource from './WorkflowResource';
import WFServiceSubscriptionResource from './WFServiceSubscriptionResource';

import {
    WarehouseResource,
    WarehouseMembersResource,
    WarehouseItemsResource,
    WarehouseItemGroupResource,
    WarehouseItemTypesResource,
    WarehouseItemCategoriesResource,
    WarehouseItemTypeSettingResource,
    WarehouseOperationResource,
    WarehouseOperationItemsResource,
    WarehouseOperationItemGroupResource,
    WarehouseTransactionResource,
} from './warehouse';

import NetworkGroupActionsResource from './NetworkGroupActionsResource';
import NomenclatureTaskTypeResource from './NomenclatureTaskTypeResource';
import ProjectGisLinesNested from './ProjectGisLinesNested';
import ProjectGispointsNestedResource from './ProjectGispointsNestedResource';
import ProjectDocumentNestedResource from './ProjectDocumentNestedResource';
import ProjectStageNestedResource from './ProjectStageNestedResource';
import ProjectResource from './ProjectResource';
import AssetResource from './AssetResource';
import DocumentLabelResource from './DocumentLabelResource';

export default {
    // A
    absorption: AbsorptionResource,
    accountingIntegrationHeading: AccountIntegrationHeadingResource,
    accountingPeriod: AccountingPeriodResource,
    accountingRange: AccountingRangeResource,
    auth: AuthResource,
    'address.geo': AddressGEOResource,
    'address.map': AddressMapResource,
    address: AddressResource,
    addressAttribute: AddressAttributeResource,
    addTaskTickets: AddTaskTicketsResource,
    airRoute: AirRouteResource,
    asset: AssetResource,
    attachment: AttachmentResource,
    attribute: AttributeResource,
    attributeType: AttributeTypeResource,
    auditEvent: AuditEventResource,
    auditEventType: AuditEventTypeResource,

    // B
    bankAccount: BankAccountResource,
    billingAccount: BillingAccountResource,
    billingAccountTransaction: BillingAccountTransactionResource,
    billingAccountAbsorption: BillingAccountAbsorptionResource,
    billingAccountFinancialDocuments: BillingAccountFinancialDocumentsResource,
    billingPeriod: BillingPeriodResource,
    billingPolicy: BillingPolicyResource,
    bills: BillsResource,

    // C
    'cabinet.geo': CabinetGEOResource,
    cabinet: CabinetResource,
    'cable.geo': CableGEOResource,
    cableReserve: CableReserveResource,
    cable: CableResource,
    cableModelNomenclature: CableModelNomenclatureResource,
    cableModel: CableModelResource,
    callDetailRecord: CallDetailRecordResource,
    cashAccount: CashAccountResource,
    celeryTasks: CeleryTaskResource,
    city: CitiesResource,
    checkedAddresses: CheckedAddressResource,
    'client.org': ClientOrganisationResource,
    'client.person': ClientPersonResource,
    'client.org.anonymous': AnonymousOrganisationResource,
    'client.person.anonymous': AnonymousPersonResource,
    'client.wfEntity': ClientWFEntityResource,
    client: ClientResource,
    'client.sys': ClientSystemResource,
    comment: CommentResource,
    contract: ContactsResource,
    continuousPipe: ContinuousPipeResource,
    'continuousPipe.geo': ContinuousPipeMapResource,
    coupler: CouplerResource,
    'coupler.geo': CouplerMapResource,
    'coverage.geo': CoverageGEOResource,
    coverage: CoverageResource,
    currency: CurrencyResource,

    // D
    dataport: DataPortResource,
    'dataport.geo': DataPortMapResource,
    document: DocumentResource,
    documentType: DocumentTypeResource,
    documentArchiveLocation: DocumentArchiveLocationResource,
    documentLabel: DocumentLabelResource,

    // E
    eitExport: EITExportResource,
    entityPaymentMethods: EntityPaymentMethodsResource,
    employee: EmployeeResource,
    entity: EntityResource,
    entityDetails: ContactDetailResource,
    entityInternalTransactionProtocol: EntityInternalTransactionProtocol,
    entityRelatedEntitiesNested: EntityRelatedEntitiesNestedResource,
    event: EventResource,
    events: EventResource,
    eventType: EventTypeResource,
    exit: ExitResource,
    escalationMatrices: EscalationMatricesResource,
    exportResult: ExportResultResource,

    // F
    'fiber.geo': FiberGEOResource,
    fiber: FiberResource,
    file: FileResource,
    fileS3: FileS3Resource,
    financialDocument: FinancialDocumentResource,
    financialDocumentDraft: FinancialDocumentDraftResource,
    financialDocumentInternalTransactionProtocols: FinancialDocumentInternalTransactionProtocolResource,
    financialDocumentList: FinancialDocumentListResource,
    financialDocumentRow: FinancialDocumentRowResource,
    financialDocumentRowNested: FinancialDocumentRowNestedResource,
    financialDocumentRelatedDocuments: FinancialDocumentRelatedDocumentsResource,
    financialDocumentPaymentNested: FinancialDocumentPaymentNestedResource,

    'fork.geo': ForkGEOResource,
    fork: ForkResource,

    // G
    'gisLine.geo': GISLineGEOResource,
    gisLine: GISLineResource,
    'gisPoint.geo': GISPointGEOResource,
    gisPoint: GISPointResource,
    'gisRegions.geo': GISRegionsGEOResource,
    group: GroupResource,
    groupActions: GroupActionsResource,

    // I
    infrastructureProvider: InfrastructureProviderResource,
    internalTransactionProtocol: InternalTransactionProtocolResource,
    inventoryType: InventoryTypeResource,

    // L
    'linecut.geo': LineCutGEOResource,
    linecut: LineCutResource,
    line: LineResource,
    location: LocationResource,

    // M
    mainServiceType: MainServiceTypeResource,
    moneyTransfer: MoneyTransferResource,
    moneyTransferDocumentNested: MoneyTransferDocumentNestedResource,
    moneyAccount: MoneyAccountResource,
    moneyTransferTransactionNested: MoneyTransferTransactionNestedResource,

    // N
    'networks.map': NetworksMapResource,
    networkGroupActions: NetworkGroupActionsResource,
    nomenclatureItemNested: NomenclatureItemNestedResource,
    nomenclatureItem: NomenclatureItemResource,
    notificationType: NotificationTypeResource,
    notificationChannel: NotificationChannelResource,
    notifications: NotificationResource,
    notificationScope: NotificationScopeResource,
    notificationTypeChannel: NotificationTypeChannelResource,
    notificationSubscription: NotificationSubscriptionResource,
    nomenclatureTaskType: NomenclatureTaskTypeResource,
    nomenclatureType: NomenclatureTypeResource,
    notificationTypeScope: NotificationTypeScopeResource,

    // O
    odf: ODFResource,
    odfNonPop: ODFNonPoPResource,
    'odf.geo': ODFMapResource,
    objectEditability: ObjectEditabilityResource,
    objectLocks: ObjectLockResource,
    objectVisibility: ObjectVisibilityResource,
    oldServiceSubscription: OldServiceSubscription,
    opticalodfport: OpticalODFPortResource,
    'opticalodfport.geo': OpticalODFPortMapResource,
    opticalswitchport: OpticalSwitchPortResource,
    'opticalswitchport.geo': OpticalSwitchPortMapResource,
    organisationRepresentative: OrganisationRepresentativeResource,
    representativeNested: RepresentativeNestedResource,
    representing: RepresentingResource,
    organisationalRegion: OrganisationalRegionResource,
    organisationalUnit: OrganisationalUnitResource,
    organisation: OrganisationResource,

    ossPort: OSSPortResource,
    ossPortNested: OSSPortNestedResource,
    ossSwitch: OSSSwitchResource,
    ossLink: OSSLinkResource,
    ossNode: OSSNodeResource,
    ossRule: OSSRuleResource,
    ossLocation: OSSLocationResource,
    ossAccount: OSSAccountResource,
    ossCpe: OSSCpeResource,
    ossPhone: OSSPhoneResource,
    ossNetwork: OSSNetworkResource,
    ossDict: OSSDictResource,
    ossTemplate: OSSTemplateResource,
    ossPricing: OSSPricingResource,

    // P
    patchCable: PatchCableResource,
    paymentOperatorAccount: PaymentOperatorAccountResource,
    paymentMethod: PaymentMethodResource,
    paymentMethodBillingAccount: PaymentMethodBillingAccountResource,
    payment: PaymentResource,
    permission: PermissionResource,
    person: PersonResource,
    phone: PhoneResource,
    'pillar.geo': PillarMapResource,
    pillar: PillarResource,
    'pipe.geo': PipeGEOResource,
    pipe: PipeResource,
    'pop.geo': PoPGEOResource,
    pop: PoPResource,
    point11: Point11Resource,
    point12: Point12Resource,
    point: PointResource,
    pricingPlan: PricingPlanResource,
    process: ProcessResource,
    projects: ProjectResource,
    projectsStageNested: ProjectStageNestedResource,
    projectDocumentNested: ProjectDocumentNestedResource,
    projectGisNested: ProjectGispointsNestedResource,
    projectGisLinesNested: ProjectGisLinesNested,

    // Q
    quarter: QuartersResource,

    // R
    'rack.geo': RackMapResource,
    rack: RackResource,
    recurringPeriod: RecurringPeriodResource,
    role: RoleResource,
    residentialType: ResidentialTypeResource,

    // S
    sfp: SFPResource,
    'sfp.geo': SFPMapResource,
    service: ServiceResource,
    serviceDefinition: ServiceDefinitionResource,
    serviceDefinitionParameter: ServiceDefinitionParameterResource,
    serviceInventorySubscription: ServiceInventorySubscriptionNestedResource,
    subServiceSubscription: SubServiceSubscriptionNestedResource,
    serviceDefinitionParameterChildResource: ServiceDefinitionParameterChildResource,
    ServiceDefinitionManyToMany: ServiceDefinitionManyToManyResource,
    serviceManyToMany: ServiceManyToManyResource,
    serviceSubscription: ServiceSubscriptionResource,
    serviceSubscriptionParameter: ServiceSubscriptionParameterResource,
    serviceSubscriptionParameterChildResource: ServiceSubscriptionParameterChildResource,
    serviceParameter: ServiceParameterResource,
    serviceParameterNested: ServiceParameterNestedResource,
    'shaft.geo': ShaftGEOResource,
    shaft: ShaftResource,
    splice: SpliceResource,
    'splice.geo': SpliceMapResource,
    street: StreetsResource,
    system: SystemResource,
    switch: SwitchResource,
    'switch.geo': SwitchMapResource,

    // T
    task: TaskResource,
    taskForAnotherOrgUnit: TaskForAnotherOrgUnitResource,
    taskServiceLink: TaskTicketLinkServiceResource,
    taskTypeEscalationMatrices: TaskTypeEscalationMatricesResource,
    taskTicket: TaskTicketResource,
    processTasks: TaskProcessResource,
    processCounterpartyTasks: TaskProcessCounterpartyResource,
    processCommunicationTasks: TaskProcessCommunicationResource,
    techType: TechTypeResource,
    template: TemplateResource,
    terminalbox: TerminalBoxResource,
    'terminalbox.geo': TerminalBoxMapResource,
    transaction: TransactionResource,
    transactionFinancialDocumentRow: TransactionFinancialDocumentRowResource,

    // U
    user: UserResource,

    // W
    'wallpoint.geo': WallPointGEOResource,
    wallpoint: WallPointResource,
    workflow: WorkflowResource,
    warehouse: WarehouseResource,
    warehouseMembers: WarehouseMembersResource,
    warehouseItems: WarehouseItemsResource,
    warehouseItemGroup: WarehouseItemGroupResource,
    warehouseItemTypes: WarehouseItemTypesResource,
    warehouseItemCategories: WarehouseItemCategoriesResource,
    warehouseItemTypeSetting: WarehouseItemTypeSettingResource,
    warehouseOperation: WarehouseOperationResource,
    warehouseOperationItem: WarehouseOperationItemsResource,
    warehouseOperationItemGroup: WarehouseOperationItemGroupResource,
    warehouseTransaction: WarehouseTransactionResource,
    WFServiceSubscription: WFServiceSubscriptionResource,
    infrastructureDocumentPermit: InfrastructureDocumentPermitResource,
};
